export default __webpack_public_path__ + "assets/images/17d0c0af6f77ac93d9765dbb103b1a20.png";